(function () {
    ShopifyBuyInit();
    function ShopifyBuyInit() {
    var client = ShopifyBuy.buildClient({
      domain: 'easyfinances.myshopify.com',
      storefrontAccessToken: '8ca60a119e03099e07f125f318a96a23',
    });
    ShopifyBuy.UI.onReady(client).then(function (ui) {
      ui.createComponent('product', {
        id: productId,
        node: document.getElementById(nodeId),
        moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
        options: {
            "product": {
                "iframe": false,
                "layout": "horizontal",
                "order": [
                    'img',
                    'title',
                    'price',
                    'options',
                    'description',
                    'button'             
                ],
                "contents": {
                    "img": true,
                    "imgWithCarousel": false,
                    "title": true,
                    "variantTitle": false,
                    "price": true,
                    "unitPrice": false,
                    "compareAtPrice": false,
                    "options": true,
                    "quantity": false,
                    "quantityIncrement": false,
                    "quantityDecrement": false,
                    "quantityInput": true,
                    "button": true,
                    "buttonWithQuantity": false,
                    "description": true,
                },
                "text": {
                    "button": "Acheter maintenant"
                },
                "googleFonts": [
                    "Roboto"
                ]
            },
            "option": {},
            "cart": {
                "styles": {
                "button": {
                    "font-family": "Roboto, sans-serif",
                    "font-size": "17px",
                    "padding-top": "16.5px",
                    "padding-bottom": "16.5px",
                    ":hover": {
                    "background-color": "#c7424f"
                    },
                    "background-color": "#dd4958",
                    ":focus": {
                    "background-color": "#c7424f"
                    }
                }
                },
                "text": {
                "total": "Subtotal",
                "button": "Checkout"
                },
                "googleFonts": [
                "Roboto"
                ]
            },
            "toggle": {
                "styles": {
                "toggle": {
                    "font-family": "Roboto, sans-serif",
                    "background-color": "#dd4958",
                    ":hover": {
                    "background-color": "#c7424f"
                    },
                    ":focus": {
                    "background-color": "#c7424f"
                    }
                },
                "count": {
                    "font-size": "17px"
                }
                },
                "googleFonts": [
                "Roboto"
                ]
            }
        },
      });
    });
  }
})();